function addNewParameter( endpointId) {
	return {
		type: 'ADD_NEW_PARAMETER',
		payLoad: {
			endpointId
		}
	}
}

function addNewParameterFilled( endpointId, name ) {
  return {
    type: 'ADD_NEW_PARAMETER_FILLED',
    payLoad: {
      endpointId,
      name
    }
  }
}

function changeParameter( endpointId, paramId, field, value ) {
	return {
		type: 'CHANGE_PARAMETER',
		payLoad: {
			endpointId,
			paramId,
			field,
			value
		}
	}
}

function removeParameter( endpointId, paramId ) {
	return {
		type: 'REMOVE_PARAMETER',
		payLoad: {
			endpointId,
			paramId
		}
	}
}

export { addNewParameter, addNewParameterFilled, changeParameter, removeParameter };
